__webpack_require__.p = "https://mn.chatie.me/assets/f5e876a1838c67388773a9aaf98b08b6c6dfbe55/_next/";